import React, { Component } from 'react';

import HttpRunner from '../query';
import examples from '../../../utils/examples';
import urlHandler from '../../../utils/urlHandler';

class DocV1AdminHealth extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    render() {
        return (
            <div className="bucket" id="top">
                 <span id="sysinfo_endpoint">
                    <span className='heading-1'>Admin Health</span>
                </span>
                <code className="api-definition">
                    <span className="get-badge">GET</span>&nbsp;{urlHandler.API_ENDPOINT_V1_ADMIN_HEALTH}
                </code>
                <div className="description">
                    An unauthenticated general health check that returns "ok" when Finch For Text is running and available for requests.
                </div>

                <div className="heading-2">Example</div>
                <div className="example-content host">
                    <pre>
                        GET {urlHandler.API_ENDPOINT_V1_ADMIN_HEALTH}<br/>
                    </pre>
                </div>

                <div>
                    <h4 className="heading-3">Response</h4>
                    <div className='example-query-response'>
                        <code id='text'>
                            <pre>ok</pre>
                        </code>
                    </div>                
                </div>
            </div>
        );
    }
}

export default DocV1AdminHealth;